// extracted by mini-css-extract-plugin
export default {"productGallery":"tN-z","inQuickShop":"uN-z"};